import { render, staticRenderFns } from "./CheckedRed.vue?vue&type=template&id=3bdad84f&"
import script from "./CheckedRed.vue?vue&type=script&lang=ts&"
export * from "./CheckedRed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports